/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Ashpandefect2Inputs */



/**
* | output |
* | --- |
* | "Ash pan defect" |
*
* @param {Br_History_Key_Ashpandefect2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_ashpandefect2 = /** @type {((inputs?: Br_History_Key_Ashpandefect2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Ashpandefect2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Ash pan defect")
	return /** @type {LocalizedString} */ ("Défaut du cendrier")
});
export { br_history_key_ashpandefect2 as "br_history_key_ashPanDefect" }